import { GameOptions } from './GameOptions';

export type GameModuleState = 'disabled' | 'enabled' | 'devOnly';
export type GameModule = {
  key: string;
  name: string;
  description: string;

  gameOptionsToApply: Partial<GameOptions>;

  replaceCore?: boolean;
  state: GameModuleState;
};

export const GameModules: GameModule[] = [
  {
    key: 'beta',
    name: 'Beta',
    description: 'Testing grounds for card updates.',
    gameOptionsToApply: {},
    state: 'disabled',
  },
  {
    key: 'altleaders',
    name: 'Alternate Random Leaders',
    description:
      'A set of random leaders with both prophecy and upgrade effects.',
    gameOptionsToApply: {
      randomLeader: true,
    },

    state: 'enabled',
  },
];
